export enum Permission {
  SELECT = "Select",
  VIEWER = "Viewer",
  ADMIN = "Admin"
}
